export const activityWatcher = ({
    idleTimeInSeconds,
    pauseAction,
    resumeAction
}) => {
    let isPaused = false;

    let idleTimeout;

    const start = () => {
        clearTimeout(idleTimeout);
        idleTimeout = setTimeout(() => {
            pause();
        }, idleTimeInSeconds * 1000);
    };

    const activity = () => {
        if (isPaused) {
            isPaused = false;
            resumeAction();
        }
        start();
    };

    const pause = () => {
        if (!isPaused) {
            isPaused = true;
            pauseAction();
        }
    };

    const activityEvents = [
        'mousedown',
        'mousemove',
        'keydown',
        'scroll',
        'touchstart'
    ];

    activityEvents.forEach(eventName => {
        document.addEventListener(eventName, activity, true);
    });

    start();
};
